import { render, staticRenderFns } from "./SpecialCategoryAdd.vue?vue&type=template&id=69c21b17&scoped=true"
import script from "./SpecialCategoryAdd.vue?vue&type=script&lang=js"
export * from "./SpecialCategoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c21b17",
  null
  
)

export default component.exports